import { removeStoreBlock } from "./zwdoc/legacy/commentStore";
import { isZwDocText, parseZwDoc } from "./zwdoc/format";
import { projectPlainText } from "./zwdoc/plainText";

const COMMENT_MARKER_RE = /<!--\s*\/?zw-c:[A-Za-z0-9_-]+\s*-->/g;

/** Whitespace-separated word count (matches the editor status bar). */
export function countWords(text: string): number {
  if (text.trim().length === 0) return 0;
  return text.split(/\s+/).filter((part) => part.length > 0).length;
}

/**
 * Manuscript prose for word metrics: drops inline comment markers and the
 * trailing `<!-- zw-comments -->` JSON store (comment bodies must not count).
 */
export function proseForWordCount(text: string): string {
  const withoutStore = removeStoreBlock(text);
  return withoutStore.replace(COMMENT_MARKER_RE, "");
}

/**
 * Word count of manuscript prose only (excludes comment markup and store).
 * `.zwdoc` text counts its plain-text projection; must match zw-core's
 * `count_manuscript_words` and zw-cloud's `WordCount.count` (#256).
 */
export function countManuscriptWords(text: string): number {
  if (isZwDocText(text)) {
    const parsed = parseZwDoc(text);
    return parsed.ok ? countWords(projectPlainText(parsed.value.doc).text) : 0;
  }
  return countWords(proseForWordCount(text));
}
